import { baseUrl } from "@/config/env";
import request from "@/router/axios";
import { parseParam } from "@/util/util";

export const findPipelineTesting = (params) => {
  params = parseParam(params);
  params = params + "&type=PIPELINE_TESTING";
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/customs_declaration/ListV2?` + params,
    method: "GET",
  });
};

export const downloadExcelPipelineTesting = (params) => {
  params = parseParam(params);
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/customs_declaration/downloadExcelHangPipeline?type=PIPELINE_TESTING&` + params,
    method: "GET",
    responseType: "blob",
  });
};

// 管道试压报单 Excel 下载（独立接口，参数：shopId/startTime/endTime，毫秒时间戳）
export const downloadExcelPiplineTest = (params) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/customs_declaration/downloadExcelPiplineTest`,
    method: "GET",
    params,
    responseType: "blob",
  });
};
